// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Card,
//   CardBody,
//   CardHeader,
//   Col,
//   Container,
//   Input,
//   Row,
// } from "reactstrap";
// import Skeleton from "react-loading-skeleton";
// import BookTripForm from "../../Forms/Transaction/BookTripForm";
// import CustomPagination from "../../../Components/Common/CustomePagination";

// const CreditNote = () => {
//   const [isFormOpen, setIsFormOpen] = useState(false);
//   const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
//   const [isViewModalOpen, setIsViewModalOpen] = useState(false);
//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [isEditOpen, setIsEditOpen] = useState(false);

//   return (
//     <div className="page-content">
//       <Container fluid>
//         <Row>
//           <Col lg={12}>
//             <Card>
//               <CardHeader>
//                 <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 w-100">
//                   <h4 className="card-title mb-0">Credit Notes</h4>

//                   {!isFormOpen && !isEditOpen ? (
//                     <Button color="primary" className="btn btn-sm">
//                       <i className="ri-add-line align-bottom me-1"></i>
//                       Generate Credit Note
//                     </Button>
//                   ) : (
//                     <Button
//                       color="secondary"
//                       className="btn btn-sm"
//                       onClick={() => {
//                         setIsFormOpen(false);
//                         setIsEditOpen(false);
//                         setSelectedTrip(null);
//                       }}
//                     >
//                       <i className="ri-arrow-left-line align-bottom me-1"></i>
//                       Back to Listing
//                     </Button>
//                   )}
//                 </div>
//               </CardHeader>

//               <CardBody>
//                 {isFormOpen ? (
//                   <BookTripForm
//                     customers={customers}
//                     vehicles={vehicles}
//                     sessions={activeSessions}
//                     suppliers={suppliers}
//                     onSubmit={async (bookedTrip) => {
//                       await handeBookTrip(bookedTrip);
//                       setIsFormOpen(false);
//                     }}
//                     // onCloseForm={setIsFormOpen(false)}
//                   />
//                 ) : (
//                   <>
//                     {/* Search */}
//                     <div className="d-flex justify-content-between align-items-center mb-3">
//                       <div className="search-box w-25">
//                         <Input
//                           type="text"
//                           className="form-control"
//                           placeholder="Search trips..."
//                         />
//                       </div>

//                       {/* <div>
//                             <button
//                               onClick={() => setOrderBy(orderBy === "ASC" ? "DESC" : "ASC")}
//                             >
//                               {orderBy === "ASC" ? "Sort Desc" : "Sort Asc"}
//                             </button>
//                           </div> */}
//                     </div>

//                     {/* Table */}
//                     <div className="table-responsive">
//                       <table className="table align-middle table-nowrap">
//                         <thead className="table-light">
//                           <tr>
//                             <th>Sr No</th>
//                             <th>Trip No</th>
//                             <th>Invoice No</th>
//                             <th>Date</th>
//                             <th>Customer</th>
//                             <th>Supplier</th>
//                             <th>Vehicle</th>
//                             <th>Trip Type</th>
//                             <th>Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                       </table>
//                     </div>

//                     {/* Pagination */}
//                     {/* <div className="mt-3">
//                       <CustomPagination
//                         currentPage={pagination?.currentPage}
//                         totalPages={pagination?.totalPages}
//                         onPageChange={(page) => setPageNo(page)}
//                         pageSize={pageSize}
//                         setPageSize={setPageSize}
//                         setPageNo={setPageNo}
//                       />
//                     </div> */}
//                   </>
//                 )}
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default CreditNote;

import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  Row,
  Input,
} from "reactstrap";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

// import ConfirmModal from "../../../Components/Common/ConfirmModal";
import CustomPagination from "../../../Components/Common/CustomePagination";
import {
  addCreditNote,
  deleteCreditNote,
  updateCreditNote,
  fetchCreditNotesList,
} from "../../../slices/CreditNote/thunk";
// import GenerateCreditNoteForm from "../../Forms/Transaction/GenerateCreditNoteForm";
// import EditCreditNoteForm from "../../Forms/Transaction/EditCreditNoteForm";
import {
  fetchCreditNotePDFList,
  fetchCustomersList,
} from "../../../slices/thunks";
// import ViewCreditNoteModal from "../../../Modals/CreditNote/ViewCreditNoteModal";
import NF from "../../../assets/images/file.png";
import { CheckCircle, XCircle } from "react-feather";
import Swal from "sweetalert2";
import GenerateCreditNoteForm from "../../Forms/Transaction/GenerateCreditNoteForm";
import ConfirmModal from "../../../Components/Common/ConfirmModal";
import EditCreditNoteForm from "../../Forms/Transaction/EditCreditNoteForm";
import ViewCreditNoteModal from "../../../Modals/CreditNote/ShowCreditNoteModal";

const CreditNoteList = () => {
  const dispatch = useDispatch();

  const [showAddForm, setShowAddForm] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debounceSearch, setDebounceSearch] = useState("");

  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedCreditNote, setSelectedCreditNote] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editCreditNoteId, setEditCreditNoteId] = useState(null);

  const toggleConfirm = () => setIsConfirmOpen(!isConfirmOpen);
  const toggleViewModal = () => setShowViewModal(!showViewModal);

  const creditNoteSelector = createSelector(
    (state) => state,
    (state) => ({
      creditNotes: state.CreditNote.creditNotes,
      loading: state.CreditNote.loading,
      error: state.CreditNote.error,
      pagination: state.CreditNote.pagination,
      customers: state.Customer.customers,
      activeSessions: state.Session.selectedSessionYear,
    }),
  );

  const { creditNotes, loading, error, pagination, activeSessions, customers } =
    useSelector(creditNoteSelector);

  // When clicking Generate Credit Note
  const handleOpenAdd = () => {
    dispatch(fetchCustomersList({ isPagination: 0 }));
    setShowAddForm(true);
  };

  const handleAddCreditNote = async (creditNote) => {
    await dispatch(addCreditNote(creditNote));
    resetSearch();
    await loadCreditNotes();
  };

  const handleEditCreditNote = (creditNoteId) => {
    setEditCreditNoteId(creditNoteId);
    setShowEditForm(true);
  };

  const handleUpdateCreditNote = async (id, updatedCreditNote) => {
    await dispatch(updateCreditNote(id, updatedCreditNote));
    resetSearch();
    await loadCreditNotes();
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setIsConfirmOpen(true);
  };

  const confirmDelete = async () => {
    await dispatch(deleteCreditNote(deleteId));
    resetSearch();
    loadCreditNotes();
  };

  const handleDownloadPDF = async (creditNoteId) => {
    await dispatch(fetchCreditNotePDFList(creditNoteId));
  };

  const loadCreditNotes = async () => {
    await dispatch(
      fetchCreditNotesList({
        searchTerm: debounceSearch.trim(),
        sessionId: activeSessions?.id,
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: "DESC",
        isPagination: 1,
      }),
    );
  };

  useEffect(() => {
    const t = setTimeout(() => setDebounceSearch(searchTerm), 500);
    return () => clearTimeout(t);
  }, [searchTerm]);

  useEffect(() => {
    loadCreditNotes();
  }, [pageNo, pageSize, debounceSearch, activeSessions]);

  const handleToggleStatus = async (creditNote) => {
    const id = creditNote.id;
    const active = !creditNote.active;

    await dispatch(updateCreditNote(id, { active }));
    resetSearch();
    await loadCreditNotes();
  };

  const resetSearch = () => {
    setSearchTerm("");
    setDebounceSearch("");
    setPageNo(0);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <h4 className="card-title mb-0">
                    {showAddForm
                      ? "Generate Credit Note"
                      : showEditForm
                        ? "Edit Credit Note"
                        : "Credit Note"}
                  </h4>

                  {!showAddForm && !showEditForm ? (
                    <Button
                      color="primary"
                      className="btn btn-sm"
                      onClick={handleOpenAdd}
                    >
                      <i className="ri-add-line me-1" />
                      Generate Credit Note
                    </Button>
                  ) : showEditForm ? (
                    <Button
                      color="secondary"
                      className="btn btn-sm"
                      onClick={() => {
                        setShowEditForm(false);
                        setEditCreditNoteId(null);
                      }}
                    >
                      <i className="ri-arrow-left-line me-1" />
                      Back to Listing
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      className="btn btn-sm"
                      onClick={() => setShowAddForm(false)}
                    >
                      <i className="ri-arrow-left-line me-1" />
                      Back to Listing
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardBody>
                {showAddForm ? (
                  <GenerateCreditNoteForm
                    customersList={customers?.map((c) => ({
                      value: c.id,
                      label: c.name,
                    }))}
                    onSubmit={handleAddCreditNote}
                    onCloseForm={() => setShowAddForm(false)}
                  />
                ) : showEditForm ? (
                  <EditCreditNoteForm
                    creditNoteId={editCreditNoteId}
                    onSubmit={handleUpdateCreditNote}
                    onCloseForm={() => {
                      setShowEditForm(false);
                      setEditCreditNoteId(null);
                    }}
                  />
                ) : (
                  <>
                    {/* Search Bar */}
                    <div className="d-flex justify-content-between mb-3">
                      <div className="search-box w-25">
                        <Input
                          type="text"
                          placeholder="Search credit notes..."
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setPageNo(0);
                          }}
                        />
                      </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                      <table className="table table-nowrap align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Sr No</th>
                            <th>Credit Note No</th>
                            <th>Invoice No</th>
                            <th>Date</th>
                            <th>Customer</th>
                            {/* <th>SubTotal</th> */}
                            <th>Total Tax</th>
                            <th>Grand Total</th>
                            {/* <th>Status</th> */}
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {loading ? (
                            [...Array(pageSize)].map((_, i) => (
                              <tr key={i}>
                                {[...Array(8)].map((__, j) => (
                                  <td key={j}>
                                    <Skeleton height={10} width={70} />
                                  </td>
                                ))}
                              </tr>
                            ))
                          ) : error ? (
                            <tr>
                              <td
                                colSpan="9"
                                className="text-danger text-center"
                              >
                                {error}
                              </td>
                            </tr>
                          ) : creditNotes?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="9"
                                className="text-center text-muted"
                              >
                                <img
                                  src={NF}
                                  alt="No File"
                                  style={{ width: "500px", marginTop: "10px" }}
                                />
                              </td>
                            </tr>
                          ) : (
                            creditNotes?.map((creditNote, index) => (
                              <tr
                                key={creditNote.id}
                                onClick={() => {
                                  setSelectedCreditNote(creditNote);
                                  setShowViewModal(true);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <td>{pageNo * pageSize + index + 1}</td>
                                <td>{creditNote.creditNoteNo}</td>
                                <td>{creditNote.invoiceNo}</td>
                                <td>{creditNote.creditNoteDate}</td>

                                <td>
                                  <div
                                    style={{
                                      maxWidth: "100px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                    title={creditNote.customerName}
                                  >
                                    {creditNote.customerName || "-"}
                                  </div>
                                </td>
                                {/* <td>{creditNote.subTotal}</td> */}
                                <td>{creditNote.totalGst}</td>
                                <td>{creditNote.grandTotal}</td>
                                {/* <td
                                  style={{
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleToggleStatus(creditNote);
                                  }}
                                >
                                  {creditNote.active ? (
                                    <CheckCircle
                                      size={20}
                                      color="#16a34a"
                                      title="Active - Click to deactivate"
                                    />
                                  ) : (
                                    <XCircle
                                      size={20}
                                      color="#dc2626"
                                      title="Inactive - Click to activate"
                                    />
                                  )}
                                </td> */}

                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <button
                                      className="btn btn-sm btn-outline-success btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleEditCreditNote(creditNote?.id);
                                      }}
                                    >
                                      <i className="ri-edit-2-line"></i>
                                    </button>

                                    <button
                                      className="btn btn-sm btn-outline-danger btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(creditNote?.id);
                                      }}
                                    >
                                      <i className="ri-delete-bin-line"></i>
                                    </button>
                                    <button
                                      className="btn btn-sm btn-outline-primary btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownloadPDF(creditNote?.id);
                                      }}
                                    >
                                      <i class="ri-printer-line"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <CustomPagination
                      currentPage={pagination?.currentPage}
                      totalPages={pagination?.totalPages}
                      onPageChange={(page) => setPageNo(page)}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      setPageNo={setPageNo}
                    />
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* DELETE CONFIRM */}
      <ConfirmModal
        isOpen={isConfirmOpen}
        toggle={toggleConfirm}
        title="Delete Credit Note"
        message="Are you sure you want to delete this credit note?"
        onConfirm={confirmDelete}
      />

      <ViewCreditNoteModal
        show={showViewModal}
        toggle={toggleViewModal}
        creditNote={selectedCreditNote}
      />
    </div>
  );
};

export default CreditNoteList;
